import { render, staticRenderFns } from "./CbsPagination.vue?vue&type=template&id=5f69b924&"
import script from "./CbsPagination.vue?vue&type=script&lang=js&"
export * from "./CbsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports